// extracted by mini-css-extract-plugin
module.exports = {"total":"style_total__27ddA"};